// Läser av gratisnivåns status (tid kvar och kvoter) för inloggat konto.
import { useCallback, useEffect, useState } from "react";
import { fetchFreeTierState, type FreeTierState } from "@/lib/plan/freeTier";

export const useFreeTier = () => {
  const [state, setState] = useState<FreeTierState | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    setState(await fetchFreeTierState());
    setLoading(false);
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const isFree = Boolean(state?.is_free);

  return {
    state,
    loading,
    reload: load,
    isFree,
    /** Gratisnivån ger full åtkomst så länge provperioden löper. */
    hasFullTrialAccess: isFree && !state?.expired,
    trialExpired: isFree && Boolean(state?.expired),
  };
};
